import React, { useState, useMemo, Suspense } from 'react';
import './MedicinalPage.css'; // Reusing the same styling

const EnlargedImage = React.lazy(() => import('./EnlargedImage'));

const PhotoItem = React.memo(({ src, alt, onClick }) => {
  return (
    <div className="photo-item">
      <img
        src={src}
        alt={alt}
        className="photo-img"
        loading="lazy"
        onClick={onClick}
      />
    </div>
  );
});

function Annual2025Page() {
  const totalImages = 20;
  const [viewAll, setViewAll] = useState(false);
  const [enlargedImage, setEnlargedImage] = useState(null);

  const visibleCount = viewAll ? totalImages : 6;

  const loadImage = (index) => `/images/annual_day_2025/${index + 1}.jpg`;

  const visibleImages = useMemo(() => {
    return Array.from({ length: visibleCount }, (_, index) => ({
      src: loadImage(index),
      alt: `Annual Day 2025 - ${index + 1}`,
    }));
  }, [visibleCount]);

  return (
    <div className="photos-container">
      <h2 className="photos-heading">ANNUAL DAY CELEBRATION - 2025</h2>

      {enlargedImage && (
        <Suspense fallback={<div className="loading-overlay">Loading...</div>}>
          <EnlargedImage image={enlargedImage} onClose={() => setEnlargedImage(null)} />
        </Suspense>
      )}

      <div className="photos-grid">
        {visibleImages.map((image, index) => (
          <PhotoItem
            key={index}
            src={image.src}
            alt={image.alt}
            onClick={() => setEnlargedImage(image.src)}
          />
        ))}
      </div>

      {!viewAll && totalImages > 6 && (
        <div className="view-all-btn-wrapper">
          <button className="view-all-btn" onClick={() => setViewAll(true)}>
            View All
          </button>
        </div>
      )}
    </div>
  );
}

export default Annual2025Page;
